import { render, staticRenderFns } from "./GroupBookingDeleteConformationDialog.vue?vue&type=template&id=fefca16a&scoped=true&"
import script from "./GroupBookingDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefca16a",
  null
  
)

export default component.exports